import { useRef, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Plus, Tag, MapPin } from 'lucide-react';
import WarehouseSubNav, { WarehouseSubTab } from './WarehouseSubNav';
import WarehouseListView, { WarehouseListViewRef } from './WarehouseListView';
import ProductsListView, { ProductsListViewRef } from './ProductsListView';
import ProductCategoryManagerModal from './modals/ProductCategoryManagerModal';
import ProductOriginManagerModal from './modals/ProductOriginManagerModal';

const WarehouseTab = () => {
  const [activeSubTab, setActiveSubTab] = useState<WarehouseSubTab>('warehouse');
  const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
  const [isOriginModalOpen, setIsOriginModalOpen] = useState(false);
  
  const warehouseViewRef = useRef<WarehouseListViewRef>(null);
  const productsViewRef = useRef<ProductsListViewRef>(null);

  const handleCreate = () => {
    if (activeSubTab === 'warehouse') {
      warehouseViewRef.current?.createNew();
    } else {
      productsViewRef.current?.createNew();
    }
  };

  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <div className="flex items-center justify-between min-h-10">
          <h2 className="text-2xl font-bold">Almacén</h2>

          <div className="flex items-center gap-2">
            {activeSubTab === 'products' && (
              <>
                <Button
                  variant="outline"
                  onClick={() => setIsCategoryModalOpen(true)}
                  className="flex items-center gap-2"
                >
                  <Tag size={16} />
                  Categorías
                </Button>
                <Button
                  variant="outline"
                  onClick={() => setIsOriginModalOpen(true)}
                  className="flex items-center gap-2"
                >
                  <MapPin size={16} />
                  Origen
                </Button>
              </>
            )}
            <Button
              onClick={handleCreate}
              className="bg-brand-primary hover:bg-brand-primary-hover flex items-center gap-2"
            >
              <Plus size={16} />
              {activeSubTab === 'warehouse' ? 'Agregar al Almacén' : 'Nuevo Producto'}
            </Button>
          </div>
        </div>

        <WarehouseSubNav
          activeSubTab={activeSubTab}
          onSubTabChange={setActiveSubTab}
        />
      </div>

      {activeSubTab === 'warehouse' ? (
        <WarehouseListView ref={warehouseViewRef} />
      ) : (
        <ProductsListView ref={productsViewRef} />
      )}

      {/* Category Manager Modal */}
      <ProductCategoryManagerModal
        open={isCategoryModalOpen}
        onOpenChange={setIsCategoryModalOpen}
      />

      {/* Origin Manager Modal */}
      <ProductOriginManagerModal
        open={isOriginModalOpen}
        onOpenChange={setIsOriginModalOpen}
      />
    </div>
  );
};

export default WarehouseTab;
